import { render, staticRenderFns } from "./OrderPayment.vue?vue&type=template&id=35a43914&scoped=true&"
import script from "./OrderPayment.vue?vue&type=script&lang=js&"
export * from "./OrderPayment.vue?vue&type=script&lang=js&"
import style0 from "./OrderPayment.vue?vue&type=style&index=0&id=35a43914&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a43914",
  null
  
)

export default component.exports